import { http, HttpResponse } from 'msw';
import { ddDepartures, ddStops } from '../gallery/dummydata/ddPublicTransit';

export const handlersGtfs = [
  /**
   * GTFS data for departures
   */
  http.get('https://v3.gtfs-query.allbin.se/api/v2/stops', () => {
    return HttpResponse.json(ddStops);
  }),
  http.get('https://v3.gtfs-query.allbin.se/api/v2/departures', () => {
    return HttpResponse.json(ddDepartures);
  }),
];
